module.exports = __webpack_public_path__ + "static/media/zbar.wasm.b946c8e6.bin";